export default __webpack_public_path__ + "static/policy_servicing_process-62a883a5b1a1bc818df137c6eba84380.pdf";